var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconlyLightOutlineBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a936123",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 11,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 1.167h9.94v12.16H1.75V1.167z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#aa936123)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.866 2.042c-1.487 0-2.241.573-2.241 1.704v8.589a.11.11 0 0 0 .058.1.109.109 0 0 0 .115 0l3.723-2.088a.44.44 0 0 1 .43 0l3.69 2.086c.049.028.09.015.116-.001a.112.112 0 0 0 .057-.1v-8.48c0-.447 0-1.81-2.238-1.81h-3.71zM2.741 13.327a.984.984 0 0 1-.5-.138.98.98 0 0 1-.491-.854v-8.59c0-1.639 1.136-2.578 3.116-2.578h3.71c1.978 0 3.113.98 3.113 2.685v8.48a.98.98 0 0 1-.49.855.982.982 0 0 1-.988.008l-3.476-1.964-3.51 1.968a.988.988 0 0 1-.484.128z",
    fill: "#484848"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.831 5.967H4.563a.438.438 0 0 1 0-.875H8.83a.438.438 0 0 1 0 .875z",
    fill: "#484848"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyLightOutlineBookmark);
export default __webpack_public_path__ + "static/media/iconly-light-outline-bookmark.d4133203.svg";
export { ForwardRef as ReactComponent };